import { z } from "zod";

export const appEnvSchema = z.object({
  VITE_APP_ENV: z.enum(["development", "staging", "production"]),
  VITE_SUPABASE_URL: z
    .string()
    .url()
    .refine((value) => value !== "https://example.supabase.co", {
      message: "Replace the example Supabase URL with the project URL.",
    }),
  VITE_SUPABASE_PUBLISHABLE_KEY: z
    .string()
    .min(1)
    .refine((value) => value !== "replace-with-browser-safe-publishable-key", {
      message: "Replace the example Supabase publishable key.",
    }),
});

export type AppEnv = z.infer<typeof appEnvSchema>;

export function formatAppEnvError(error: z.ZodError): string {
  return error.issues
    .map((issue) => `${issue.path.join(".")}: ${issue.message}`)
    .join("; ");
}

export function parseAppEnv(rawEnv: ImportMetaEnv) {
  return appEnvSchema.safeParse(rawEnv);
}

export function validateAppEnv(rawEnv: ImportMetaEnv): AppEnv {
  const result = parseAppEnv(rawEnv);

  if (!result.success) {
    throw new Error(
      `Invalid application environment: ${formatAppEnvError(result.error)}`,
    );
  }

  return result.data;
}

export function normalizeAppEnvironment(
  value: unknown,
): AppEnv["VITE_APP_ENV"] {
  return value === "staging" || value === "production" ? value : "development";
}
